import styled from 'styled-components';

const PriceDiscount = styled.div`
  color: ${({ theme }) => theme.colors.night_blue_1};
  width: 100%;
  height: 20px;
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  display: inline-block;
`;
export default PriceDiscount;
